<template>

<div class="show-new">
    <el-form :model="form" label-position="right" label-width="100px" >
        <el-form-item label="选择代理商:">
            <el-select v-model="form.filterAgent" @change="getAgentMeal">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in agentList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="所属类别:">
            <el-select v-model="form.category" @change="changeCategory">
                <!-- <el-option label="电信" value="1"></el-option>
                <el-option label="其他卡务" value="2"></el-option>
                <el-option label="移动" value="3"></el-option>
                <el-option label="联通" value="4"></el-option>
                <el-option label="联通Q" value="6"></el-option>
                <el-option label="DCP电信" value="5"></el-option>
                <el-option label="新移动" value="7"></el-option>
                <el-option label="新联通" value="8"></el-option> -->
                 <el-option label="请选择运营商" value=""></el-option>
                 <el-option v-for="(item,index) in $store.getters.categorys" :label="item.name" :value="item.value" :key="index"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="form.category ==categorySlist['中国移动'] || form.category == categorySlist['中国联通']" label="子类别:">
            <el-select v-model="form.secondCategory" @change="getAgentMeal">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in secondCategoryList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="套餐勾选:"  >
            <div style="max-height:250px;overflow:auto">
                <el-checkbox-group v-model="filterMeal">
                    <el-checkbox v-for="(item,index) in mealList" :label="item.id+'@@'+item.name" :key="index">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </el-form-item>
    </el-form>
    <div class="align-right">
        <el-button type="primary" class="themed-button" @click="sure">确定</el-button>
        <el-button type="primary" class="themed-button" @click="cancle">取 消</el-button>
    </div>
</div>

</template>

<script type="text/ecmascript-6">
import { getAgentList,getMealListByAgentId,recommendSave } from "@/api/eventDiscountManagement/recommend.js";

import { messageBox, confirmBox } from "@/utils/common.js";
import SearchSelect from "@/components/SearchSelect";
import store from '@/store'
export default {
    props:['promotionId'],
    data(){
        return {
            form:{
                filterAgent:'',
                filterAgentName:'',
                category:"",
                secondCategory:'',
                promotionId:0
            },
            filterMeal:[],
            agentList:[],
            secondCategoryList:[],
            mealList:[],
            categorySlist:{},
        }
    },
    mounted(){
         if(store.getters.categorys.length<1){
          store.dispatch('getCategory').then(()=>{
                  if(store.getters.categorys.length>0){
            store.getters.categorys.forEach(item=>{
               let name =  item.name
               let value = item.value
                this.categorySlist[name] =value
            })
               }
          })
        }else{
             store.getters.categorys.forEach(item=>{
               let name =  item.name
               let value = item.value
                this.categorySlist[name] =value
            })
        }
        if(store.getters.secondCategory_yd.length<1||store.getters.secondCategory_lt.length<1){
           store.dispatch("getPackageType")
        }
        this._getAgentList()
        this.getAgentMeal()
    },
    methods:{
        sure(){
            this.agentList.forEach((item)=>{
                if(item.id == this.form.filterAgent){
                    this.form.filterAgentName = item.name
                    return
                }
            })
            if(this.form.filterAgent == ''){
                this.form.filterAgentName = ''
            }
            let parames = {
                promotionId: 0,
                filterMeal:this.filterMeal.join(',')
            }
            Object.assign(parames,this.form)
            recommendSave(parames).then((res)=>{
                if(res.slide_msg_key == 1){
                    messageBox(this.res.slide_msg_message_key)
                    this.$emit('close')
                    return
                }
                this.$emit('refresh')
                
            })
        },
        cancle(){
            this.$emit('close')
        },
        changeCategory(){
            if(this.form.category == this.categorySlist['中国移动']){
                // this.secondCategoryList = [
                //     {label:'请选择',value:''},
                //     {label:'GD_IOT',value:'1'},
                //     {label:'OneLink',value:'2'},
                //     {label:'深圳移动',value:'3'}
                // ]
                this.secondCategoryList = []
                if(store.getters.secondCategory_yd.length>0){
                  store.getters.secondCategory_yd.forEach(item=>{
                      if(item.groupName){
                     this.secondCategoryList.push({label:item.groupName,value:item.dictValue})
                      }
                  }) 
                }
                  this.secondCategoryList.unshift( {label:'请选择',value:''})
            }else if(this.form.category == this.categorySlist['中国联通']){
                // this.secondCategoryList = [
                //     {label:'请选择',value:''},
                //     {label:'浙江联通',value:'1'},
                //     {label:'青岛联通',value:'2'},
                //     {label:'湖南联通',value:'3'}
                // ]
                this.secondCategoryList = []
                if(store.getters.secondCategory_lt.length>0){
                  store.getters.secondCategory_lt.forEach(item=>{
                      if(item.groupName){
                     this.secondCategoryList.push({label:item.groupName,value:item.dictValue})
                      }
                  }) 
                }
                  this.secondCategoryList.unshift( {label:'请选择',value:''})
            }
            this.getAgentMeal()
        },
        getAgentMeal(){
            this.filterMeal = []
            let parames = {
                agtId:this.form.filterAgent,
                cate1:this.form.category,
                secondCategory2:this.form.secondCategory
            }
            getMealListByAgentId(parames).then((res)=>{
                if(res.mealList!=null && res.mealList.length>0){
                    this.mealList = res.mealList
                }else{
                    this.mealList = []
                }
                
            })
        },
        _getAgentList(){
            let parames = {
                promotionId:0,
                status:0
            }
            Object.assign(parames,this.form)
            getAgentList(parames).then((res)=>{
                if(res.length>0){
                    this.agentList = res
                }else{
                    this.agentList = []
                }
            })
        }

    }
}
</script>

